var moduleMap = {
	"./revert-mutation-modal": () => {
		return Promise.all(/* __federation_expose_revert_mutation_modal */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(120), __webpack_require__.e(683), __webpack_require__.e(668), __webpack_require__.e(418)]).then(() => (() => ((__webpack_require__(9052)))));
	},
	"./handlers": () => {
		return Promise.all(/* __federation_expose_handlers */[__webpack_require__.e(96), __webpack_require__.e(526), __webpack_require__.e(943)]).then(() => (() => ((__webpack_require__(712)))));
	},
	"./mutation-grid-content": () => {
		return Promise.all(/* __federation_expose_mutation_grid_content */[__webpack_require__.e(96), __webpack_require__.e(904), __webpack_require__.e(103), __webpack_require__.e(762), __webpack_require__.e(159), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(120), __webpack_require__.e(683), __webpack_require__.e(668), __webpack_require__.e(368), __webpack_require__.e(726)]).then(() => (() => ((__webpack_require__(6550)))));
	},
	"./mutation-grid-header": () => {
		return Promise.all(/* __federation_expose_mutation_grid_header */[__webpack_require__.e(96), __webpack_require__.e(904), __webpack_require__.e(762), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(120), __webpack_require__.e(280)]).then(() => (() => ((__webpack_require__(5197)))));
	},
	"./mutation-grid-item": () => {
		return Promise.all(/* __federation_expose_mutation_grid_item */[__webpack_require__.e(96), __webpack_require__.e(904), __webpack_require__.e(762), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(120), __webpack_require__.e(368), __webpack_require__.e(826)]).then(() => (() => ((__webpack_require__(1574)))));
	},
	"./mutation-overview": () => {
		return Promise.all(/* __federation_expose_mutation_overview */[__webpack_require__.e(96), __webpack_require__.e(904), __webpack_require__.e(103), __webpack_require__.e(762), __webpack_require__.e(159), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(120), __webpack_require__.e(683), __webpack_require__.e(668), __webpack_require__.e(368), __webpack_require__.e(726), __webpack_require__.e(369)]).then(() => (() => ((__webpack_require__(5399)))));
	},
	"./routes": () => {
		return Promise.all(/* __federation_expose_routes */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(536), __webpack_require__.e(806)]).then(() => (() => ((__webpack_require__(3444)))));
	},
	"./atoms": () => {
		return Promise.all(/* __federation_expose_atoms */[__webpack_require__.e(683), __webpack_require__.e(442)]).then(() => (() => ((__webpack_require__(8062)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});